<div class="bg-m1 flex h-full cursor-default flex-col">
  <div class="flex h-2 flex-1 flex-row">
    <div class="mx-6 mb-6 mt-8 flex min-w-[2px] flex-grow flex-col">
      <div class="flex h-11 flex-row items-center justify-between">
        <div class="flex h-11 w-1/4 flex-row items-center justify-start">
          <div class="flex select-none flex-row items-center">
            <div
              data-cy="builderTitle"
              class="text-s1 flex select-none items-center self-center text-2xl font-semibold"
            >
              {{ pageTitle }}
            </div>
            <div
              class="ml-7 flex cursor-pointer flex-row items-center"
              tp="Need to Save changes"
              [tpIsEnabled]="needSave === true"
              (click)="setBuilderLeft(builderLeftTree)"
            >
              <!-- <m-document-icon></m-document-icon> -->

              <button
                class="flex w-[54px] items-center justify-center text-lg focus:outline-none"
                [ngClass]="{
                  'text-m500 font-semibold': builderLeft === builderLeftTree,
                  'text-s500': builderLeft !== builderLeftTree
                }"
                [disabled]="needSave === true"
                >Files</button
              >
            </div>

            <div
              class="ml-7"
              tp="Need to Save changes"
              [tpIsEnabled]="needSave === true"
            >
              <button
                class="flex flex-shrink-0 cursor-pointer flex-row items-center focus:outline-none"
                (click)="changesOnClick()"
                [disabled]="needSave === true"
              >
                <div
                  class="flex w-[85px] flex-shrink-0 justify-center text-lg"
                  [ngClass]="{
                    'text-m500 font-semibold':
                      builderLeft === builderLeftChangesToCommit ||
                      builderLeft === builderLeftChangesToPush,
                    'text-s500':
                      builderLeft !== builderLeftChangesToCommit &&
                      builderLeft !== builderLeftChangesToPush
                  }"
                  >Changes</div
                >

                <div
                  class="text-m0 ml-4 flex h-7 min-w-7 flex-shrink-0 items-center justify-center rounded px-2 py-[1px]"
                  [ngClass]="{
                    'bg-m500':
                      builderLeft === builderLeftChangesToCommit ||
                      builderLeft === builderLeftChangesToPush,
                    'bg-g1':
                      builderLeft !== builderLeftChangesToCommit &&
                      builderLeft !== builderLeftChangesToPush &&
                      repo?.changesToPush?.length > 0,
                    'bg-m600':
                      builderLeft !== builderLeftChangesToCommit &&
                      builderLeft !== builderLeftChangesToPush &&
                      !(repo?.changesToPush?.length > 0) &&
                      repo?.changesToCommit?.length > 0,
                    'bg-s400':
                      builderLeft !== builderLeftChangesToCommit &&
                      builderLeft !== builderLeftChangesToPush &&
                      !(repo?.changesToPush?.length > 0) &&
                      !(repo?.changesToCommit?.length > 0)
                  }"
                >
                  {{
                    repo?.changesToPush?.length > 0
                      ? repo?.changesToPush?.length
                      : repo?.changesToCommit?.length
                  }}
                </div>
              </button>
            </div>

            <div
              *ngIf="nav?.repoType === repoTypeEnum.Session"
              class="ml-8 flex cursor-pointer flex-row items-center"
              (click)="setBuilderLeft(builderLeftInfo)"
            >
              <button
                class="flex w-[80px] items-center justify-center text-lg focus:outline-none"
                [ngClass]="{
                  'text-m500 font-semibold': builderLeft === builderLeftInfo,
                  'text-s500': builderLeft !== builderLeftInfo
                }"
                >Session</button
              >
            </div>
          </div>
        </div>

        <div
          class="flex min-w-0 flex-1 flex-row items-center overflow-hidden"
          *ngIf="!!repo"
        >
          <div class="flex flex-1"></div>

          <div
            tp="Production repo is a read-only version of a Remote repo. Switch to the Dev repo to enter development mode."
            *ngIf="
              nav?.repoType === repoTypeEnum.Production && isEditor === true
            "
            class="text-s500 mr-5 flex h-11 flex-shrink-0 flex-row items-center text-lg font-semibold"
          >
            production - {{ nav.branchId }}
          </div>

          <div
            *ngIf="nav?.repoType === repoTypeEnum.Session && isEditor === true"
            class="text-s500 mr-5 flex h-11 flex-shrink-0 select-none flex-row items-center text-lg font-semibold"
          >
            session - {{ nav.branchId }}
          </div>

          <div
            *ngIf="nav?.repoType === repoTypeEnum.Dev && isEditor === true"
            class="text-s500 mr-5 flex h-11 flex-shrink-0 select-none flex-row items-center text-lg font-semibold"
          >
            dev-{{ user.alias }} - {{ nav.branchId }}
          </div>

          <ng-template #templateCommit>
            <div *ngIf="needSave === true">Need to Save changes</div>

            <!-- <div
              *ngIf="
                needSave === false && repo.conflicts.length > 0
              "
              >Need to Resolve conflicts</div
            > -->

            <div
              *ngIf="
                needSave === false && repo.repoStatus === repoStatusNeedPull
              "
              >Need to Pull changes from Remote</div
            >

            <div
              *ngIf="
                needSave === false &&
                (repo.repoStatus === repoStatusOk ||
                  repo.repoStatus === repoStatusNeedPush)
              "
              >No changes to commit</div
            >
          </ng-template>

          <div
            class="flex-shrink-0"
            *ngIf="isEditor === true"
            [tp]="templateCommit"
            [tpIsEnabled]="
              repo.repoStatus !== repoStatusNeedCommit || needSave === true
            "
          >
            <button
              type="button"
              data-cy="filesCommitButton"
              class="text-m0 ml-3 h-11 select-none rounded px-5 py-2 text-base font-medium focus:outline-none"
              [ngClass]="{
                'bg-s400 cursor-default':
                  repo.repoStatus !== repoStatusNeedCommit || needSave === true,
                'bg-m600':
                  repo.repoStatus === repoStatusNeedCommit && needSave === false
              }"
              (click)="commit()"
              [disabled]="
                repo.repoStatus !== repoStatusNeedCommit || needSave === true
              "
              >Commit</button
            >
          </div>

          <ng-template #templatePullFromRemote>
            <div *ngIf="needSave === true">Need to Save changes</div>
          </ng-template>

          <div
            class="flex-shrink-0"
            *ngIf="isEditor === true && repo.repoStatus === repoStatusNeedPull"
            [tp]="templatePullFromRemote"
            [tpIsEnabled]="needSave === true"
          >
            <button
              type="button"
              data-cy="filesPullFromRemoteButton"
              class="text-m0 ml-3 h-11 rounded px-5 py-2 text-base font-medium focus:outline-none"
              [ngClass]="{
                'bg-s400 cursor-default':
                  repo.repoStatus !== repoStatusNeedPull || needSave === true,
                'bg-m600':
                  repo.repoStatus === repoStatusNeedPull && needSave === false
              }"
              (click)="pull()"
              [disabled]="
                repo.repoStatus !== repoStatusNeedPull || needSave === true
              "
              >Pull from Remote</button
            >
          </div>

          <ng-template #templatePushToRemote>
            <div *ngIf="needSave === true">Need to Save changes</div>

            <div
              *ngIf="
                needSave === false && repo.repoStatus === repoStatusNeedCommit
              "
              >Need to Commit changes</div
            >

            <!-- <div
              *ngIf="
                needSave === false && repo.conflicts.length > 0
              "
              >Need to Resolve conflicts</div
            > -->

            <div
              *ngIf="
                needSave === false && repo.repoStatus === repoStatusNeedPull
              "
              >Need to Pull changes from Remote</div
            >

            <div *ngIf="needSave === false && repo.repoStatus === repoStatusOk"
              >No committed changes to Push</div
            >

            <div
              *ngIf="
                needSave === false &&
                nav?.repoType === repoTypeEnum.Session &&
                repo?.changesToCommit?.length === 0 &&
                repo?.changesToPush?.length === 0 &&
                repo.repoStatus === repoStatusNeedPush &&
                session?.archiveReason !== archiveReasonCommit
              "
              >No committed changes to Push</div
            >
          </ng-template>

          <div
            class="flex-shrink-0"
            *ngIf="isEditor === true"
            [tp]="templatePushToRemote"
            [tpIsEnabled]="
              repo.repoStatus !== repoStatusNeedPush ||
              needSave === true ||
              (nav?.repoType === repoTypeEnum.Session &&
                repo?.changesToCommit?.length === 0 &&
                repo?.changesToPush?.length === 0 &&
                session?.archiveReason !== archiveReasonCommit)
            "
          >
            <button
              type="button"
              data-cy="filesPushButton"
              class="text-m0 ml-3 h-11 select-none rounded px-5 py-2 text-base font-medium focus:outline-none"
              [ngClass]="{
                'bg-m600':
                  needSave === false &&
                  !(
                    nav?.repoType === repoTypeEnum.Session &&
                    repo?.changesToCommit?.length === 0 &&
                    repo?.changesToPush?.length === 0 &&
                    session?.archiveReason !== archiveReasonCommit
                  ) &&
                  (repo.repoStatus === repoStatusNeedPush ||
                    (repo.repoStatus === repoStatusOk &&
                      repo?.changesToCommit?.length === 0 &&
                      repo?.changesToPush?.length > 0)),
                'bg-s400 cursor-default':
                  needSave === true ||
                  (nav?.repoType === repoTypeEnum.Session &&
                    repo?.changesToCommit?.length === 0 &&
                    repo?.changesToPush?.length === 0 &&
                    session?.archiveReason !== archiveReasonCommit) ||
                  (repo.repoStatus !== repoStatusNeedPush &&
                    !(
                      repo.repoStatus === repoStatusOk &&
                      repo?.changesToCommit?.length === 0 &&
                      repo?.changesToPush?.length > 0
                    ))
              }"
              (click)="push()"
              [disabled]="
                needSave === true ||
                (nav?.repoType === repoTypeEnum.Session &&
                  repo?.changesToCommit?.length === 0 &&
                  repo?.changesToPush?.length === 0 &&
                  session?.archiveReason !== archiveReasonCommit) ||
                (repo.repoStatus !== repoStatusNeedPush &&
                  !(
                    repo.repoStatus === repoStatusOk &&
                    repo?.changesToCommit?.length === 0 &&
                    repo?.changesToPush?.length > 0
                  ))
              "
              >Push to Remote</button
            >
          </div>

          <div
            class="flex-shrink-0"
            *ngIf="isEditor === true"
            tp="Need to Save changes"
            [tpIsEnabled]="needSave === true"
          >
            <button
              tp="Refresh repo status (git fetch). Does not validate files."
              type="button"
              data-cy="filesRefreshButton"
              class="ml-4 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
              [ngClass]="{
                'cursor-default': needSave === true,
                'hover:bg-m200': needSave === false
              }"
              [disabled]="needSave === true"
              (click)="refresh()"
            >
              <m-refresh-icon></m-refresh-icon>
            </button>
          </div>

          <div
            class="relative ml-3 mr-9 flex-shrink-0"
            [ngClass]="{
              'mr-[72px]': !secondFileNodeId,
              'mr-4': !!secondFileNodeId
            }"
            *ngIf="isEditor === true"
          >
            <m-repo-options></m-repo-options>
          </div>
        </div>

        <div
          class="flex flex-row items-center justify-end"
          [ngClass]="{
            'w-1/4': !secondFileNodeId,
            'flex-1': !!secondFileNodeId
          }"
        >
          <div class="flex flex-row items-center">
            <button
              *ngIf="showEventsButton"
              tp="Toggle events"
              type="button"
              class="mr-7 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
              [ngClass]="{
                'bg-orange-100 text-orange-700': showEvents,
                'text-s500 hover:bg-m200': !showEvents
              }"
              (click)="toggleShowEvents()"
            >
              <m-scroll-icon></m-scroll-icon>
            </button>

            <button
              class="flex w-[90px] select-none items-center justify-center text-lg focus:outline-none"
              [ngClass]="{
                'text-m500 font-semibold':
                  builderRight === builderRightSessions &&
                  !secondFileNodeId &&
                  (builderLeft === builderLeftTree ||
                    builderLeft === builderLeftInfo ||
                    lastUrl === pathNewSession ||
                    lastUrl === pathSelectFile ||
                    !file?.fileId),
                'text-s500':
                  builderRight !== builderRightSessions ||
                  !(
                    !secondFileNodeId &&
                    (builderLeft === builderLeftTree ||
                      builderLeft === builderLeftInfo ||
                      lastUrl === pathNewSession ||
                      lastUrl === pathSelectFile ||
                      !file?.fileId)
                  )
              }"
              (click)="setBuilderRight(builderRightSessions)"
              >Sessions</button
            >

            <div
              tp="FileEditor role is required"
              [tpIsEnabled]="isEditor === false && isAdmin === false"
            >
              <button
                class="ml-7 flex w-[150px] select-none items-center justify-center text-lg focus:outline-none"
                [ngClass]="{
                  'text-m500 font-semibold':
                    builderRight === builderRightSchema &&
                    !secondFileNodeId &&
                    (builderLeft === builderLeftTree ||
                      builderLeft === builderLeftInfo ||
                      lastUrl === pathNewSession ||
                      lastUrl === pathSelectFile ||
                      !file?.fileId),
                  'text-s500':
                    builderRight !== builderRightSchema ||
                    secondFileNodeId ||
                    !(
                      builderLeft === builderLeftTree ||
                      builderLeft === builderLeftInfo ||
                      lastUrl === pathNewSession ||
                      lastUrl === pathSelectFile ||
                      !file?.fileId
                    ),
                  'cursor-default opacity-60':
                    isEditor === false && isAdmin === false
                }"
                [disabled]="isEditor === false && isAdmin === false"
                (click)="setBuilderRight(builderRightSchema)"
                >DWH Schema</button
              >
            </div>

            <button
              class="ml-7 mr-5 flex w-[155px] select-none flex-row items-center justify-center text-lg focus:outline-none"
              [ngClass]="{
                'text-m500 font-semibold':
                  builderRight === builderRightValidation &&
                  !secondFileNodeId &&
                  (builderLeft === builderLeftTree ||
                    builderLeft === builderLeftInfo ||
                    lastUrl === pathNewSession ||
                    lastUrl === pathSelectFile ||
                    !file?.fileId),
                'text-s500':
                  builderRight !== builderRightValidation ||
                  !(
                    !secondFileNodeId &&
                    (builderLeft === builderLeftTree ||
                      builderLeft === builderLeftInfo ||
                      lastUrl === pathNewSession ||
                      lastUrl === pathSelectFile ||
                      !file?.fileId)
                  )
              }"
              (click)="setBuilderRight(builderRightValidation)"
              ><span class="w-[100px]">Validation</span>
              <div
                class="text-m0 ml-4 flex h-7 min-w-7 flex-shrink-0 select-none items-center justify-center rounded px-2 py-[1px]"
                [ngClass]="{
                  'bg-m500':
                    builderRight === builderRightValidation &&
                    !secondFileNodeId &&
                    (builderLeft === builderLeftTree ||
                      builderLeft === builderLeftInfo ||
                      lastUrl === pathNewSession ||
                      lastUrl === pathSelectFile ||
                      !file?.fileId),
                  'bg-a500':
                    (builderRight !== builderRightValidation ||
                      !(
                        !secondFileNodeId &&
                        (builderLeft === builderLeftTree ||
                          builderLeft === builderLeftInfo ||
                          lastUrl === pathNewSession ||
                          lastUrl === pathSelectFile ||
                          !file?.fileId)
                      )) &&
                    nav?.needValidate === true,
                  'bg-r1':
                    (builderRight !== builderRightValidation ||
                      !(
                        !secondFileNodeId &&
                        (builderLeft === builderLeftTree ||
                          builderLeft === builderLeftInfo ||
                          lastUrl === pathNewSession ||
                          lastUrl === pathSelectFile ||
                          !file?.fileId)
                      )) &&
                    nav?.needValidate === false &&
                    struct?.errors?.length > 0,
                  'bg-s400':
                    (builderRight !== builderRightValidation ||
                      !(
                        !secondFileNodeId &&
                        (builderLeft === builderLeftTree ||
                          builderLeft === builderLeftInfo ||
                          lastUrl === pathNewSession ||
                          lastUrl === pathSelectFile ||
                          !file?.fileId)
                      )) &&
                    nav?.needValidate === false &&
                    !(struct?.errors?.length > 0)
                }"
                >{{ struct?.errors?.length }}</div
              ></button
            >
          </div>
        </div>
      </div>

      <div class="mt-6 flex h-2 flex-1 flex-row">
        <div class="flex w-1/4 flex-shrink-0">
          <m-builder-left
            [builderLeft]="builderLeft"
            [isEditor]="isEditor"
            (newFileClick)="newFile()"
            (builderLeftChange)="setBuilderLeft($event)"
            class="flex w-full"
          ></m-builder-left>
        </div>

        <div class="ml-6 flex flex-1 flex-col">
          <div class="bg-m0 flex h-full flex-grow rounded shadow">
            <div class="h-full w-full">
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>

        <div
          class="ml-6 flex"
          [ngClass]="{
            'w-1/4 flex-shrink-0': !secondFileNodeId,
            'flex-1': !!secondFileNodeId
          }"
          *ngIf="
            builderLeft === builderLeftTree ||
            builderLeft === builderLeftInfo ||
            lastUrl === pathNewSession ||
            lastUrl === pathSelectFile ||
            !file?.fileId
          "
        >
          <m-builder-right class="flex w-full"></m-builder-right>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="routerEvents$ | async"></div>
<div *ngIf="nav$ | async"></div>
<div *ngIf="secondFileNodeId$ | async"></div>
<div *ngIf="file$ | async"></div>
<div *ngIf="repo$ | async"></div>
<div *ngIf="struct$ | async"></div>
<div *ngIf="builderLeft$ | async"></div>
<div *ngIf="builderRight$ | async"></div>
<div *ngIf="showEvents$ | async"></div>
<div *ngIf="sessionId$ | async"></div>
<div *ngIf="needSave$ | async"></div>
<div *ngIf="isEditor$ | async"></div>
<div *ngIf="isAdmin$ | async"></div>
<div *ngIf="user$ | async"></div>
